import React from "react";
import { Box } from "@mui/material";

function Text({ html, small = false }) {
	return (
		<Box
			className="text"
			dangerouslySetInnerHTML={{
				__html: `${html}<span style="display: block; clear: both; margin-top: 0"></span>`,
			}}
			sx={(theme) => ({
				"& > *": {
					marginTop: theme.spacing(2),
					marginBottom: 0,
					"&:first-child": {
						marginTop: 0,
					},
				},
				"& .drupal-media": {
					display: "block",
					position: "relative",
					textDecoration: "none",
					"& figure": {
						marginInlineStart: 0,
						marginInlineEnd: 0,
					},
					"& figcaption": {
						fontSize: "0.75em",
						fontStyle: "normal",
						color: theme.palette.grey["700"],
						"& em": {
							display: "block",
							textAlign: "right",
							fontStyle: "italic",
						},
					},
					"&::after": {
						display: "none !important",
					},
					"&.drupal-media-embed": {
						backgroundColor: theme.palette.grey["700"],
						"& > div": {
							position: "relative",
							paddingTop: "56.25%",
							"& > iframe": {
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
							},
						},
						"&.align-left, &.align-right": {
							width: "50%",
							[theme.breakpoints.down("sm")]: {
								width: "100%",
							},
						},
					},
				},
				"& img, & .drupal-media": {
					"&.align-left": {
						float: "left",
						marginRight: theme.spacing(3),
					},
					"&.align-right": {
						float: "right",
						marginLeft: theme.spacing(3),
					},
					"&.align-center": {
						marginLeft: "auto",
						marginRight: "auto",
						clear: "both",
					},
					"&.align-left, &.align-right": {
						maxWidth: "50%",
						marginBottom: theme.spacing(3),
						[theme.breakpoints.down("sm")]: {
							width: "100%",
							float: "none",
							marginLeft: 0,
							marginRight: 0,
						},
					},
				},
				"& img": {
					maxWidth: "100%",
					height: "auto",
				},
				"& p, & li": {
					fontSize: "1em",
					"&.center": {
						textAlign: "center",
					},
					...(small && { fontSize: "0.9em" }),
				},
				"&.line-height-lg": {
					"& > *": {
						margin: theme.spacing(3, 0, 0, 0),
						"&:first-child": {
							marginTop: 0,
						},
					},
				},
				"&.line-height-sm": {
					"& > *": {
						margin: theme.spacing(1, 0, 0, 0),
						"&:first-child": {
							marginTop: 0,
						},
					},
				},
				"& ul, & ol, & blockquote": {
					"& > *": {
						margin: theme.spacing(1, 0, 0, 0),
						"&:first-child": {
							marginTop: 0,
						},
					},
				},
				"& a": {
					color: theme.palette.link.main,
					"&:hover, &:active, &:focus": {
						color: theme.palette.link.hover,
						textDecoration: "none",
					},
				},
				"& blockquote": {
					fontSize: "1.1em",
					backgroundColor: theme.palette.grey.lighter,
					padding: theme.spacing(4, 5),
					borderLeft: `${theme.palette.grey.light} ${theme.spacing(2)} solid`,
				},
				"& .table-responsive": {
					overflowX: "auto",
					"-webkit-overflow-scrolling": "touch",
					"& table": {
						width: "100%",
						marginBottom: theme.spacing(1),
						verticalAlign: "middle",
						borderColor: theme.palette.grey["200"],
						borderCollapse: "collapse",
						"& > caption": {
							textAlign: "left",
							fontWeight: theme.typography.fontWeightBold,
							color: theme.palette.grey["500"],
							marginBottom: theme.spacing(1),
						},
						"& > :not(caption) > * > *": {
							padding: theme.spacing(2, 2),
							backgroundColor: "white",
							borderBottomWidth: 2,
							borderBottomColor: theme.palette.grey["200"],
							borderBottomStyle: "solid",
						},
						"& > :not(caption) > * > th": {
							backgroundColor: theme.palette.grey["100"],
						},
						"& > tbody": {
							verticalAlign: "inherit",
						},
						"& > thead": {
							verticalAlign: "bottom",
						},
						"& > :not(:first-child)": {
							borderTop: `(4) solid ${theme.palette.grey["500"]}`,
						},
					},
				},
			})}
		/>
	);
}

export default Text;
